export default __webpack_public_path__ + "static/media/Pistol_9.94b5993e.png";